/**
 * Stock Controller
 * Handles all stock-related API calls
 */

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const getAuthHeaders = () => {
  const authToken = localStorage.getItem('authToken');
  return {
    Authorization: authToken ? `Bearer ${authToken}` : ''
  };
};

const StockController = {
  fetchStocks: async (pageNumber = 1, size = 10, depotId = null, productId = null, searchTerm = '') => {
    let url = `${API_URL}/Stock/Pagination?Size=${size}&PageNumber=${pageNumber}`;
    if (depotId) url += `&DepotId=${depotId}`;
    if (productId) url += `&ProductId=${productId}`;
    if (searchTerm) url += `&Search=${encodeURIComponent(searchTerm)}`;
    const response = await axios.get(url, { headers: getAuthHeaders() });
    return response.data;
  },

  fetchStocksGrouped: async (pageNumber = 1, size = 10, depotId = null, searchTerm = '') => {
    let url = `${API_URL}/Stock/Grouped?Size=${size}&PageNumber=${pageNumber}`;
    if (depotId) url += `&DepotId=${depotId}`;
    if (searchTerm) url += `&Search=${encodeURIComponent(searchTerm)}`;
    const response = await axios.get(url, { headers: getAuthHeaders() });
    return response.data;
  },

  updateQuantite: async (id, quantite) => {
    const response = await axios.put(
      `${API_URL}/Stock/Quantite`,
      { id, quantite: Number(quantite) },
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  cleanupOrphans: async () => {
    const response = await axios.post(`${API_URL}/Stock/CleanupOrphans`, {}, { headers: getAuthHeaders() });
    return response.data;
  },

  // Fetch per-depot stock breakdown for one or many products (from the Stock table).
  // Returns an array of StockLineDTO: { id, depotId, depotName, productId, productVariantId, variantName, variantReference, quantite }
  getByProducts: async (productIds = []) => {
    const ids = Array.isArray(productIds) ? productIds : [productIds];
    if (ids.length === 0) return [];
    const response = await axios.get(
      `${API_URL}/Stock/ByProducts?productIds=${ids.join(',')}`,
      { headers: getAuthHeaders() }
    );
    return response.data || [];
  },
};

export default StockController;
